// Vendors
import { push } from 'connected-react-router';

// requests
import { lookupAppLinkRequest } from '../../../backend/agencyRequests';
import { userVerifyAddressRequest } from '../../../backend/userRequests';

import {
  checkRequestFailure,
  handleRequestFailure,
  ERRORS_MAP,
} from '../../../lib/validation';

//actions
import { APP_TRANSACTION_IDS, clearAppData, storeBasicInfo } from '../../app/appActions';
import { openModal } from '../../modal/modalActions';
//helpers
import { 
  to,
  cloneObject,
  formatAddressFromForm
} from '../../../lib/helpers';

//constants
export const TXRC_TXRCLICENSERENEWAL_CLEAR_DATA = '[TXRC] TXRC_LICENSERENEWAL - Clear Data';
export const TXRC_MANAGE_SERVICE_ACTION = '[TXRC] Manage Service Action';
export const TXRC_SET_STEPS_CONFIG = '[TXRC] Set Steps Config';
export const TXRC_STORE_DETAILED_LOOKUP = '[TXRC] Store Detailed Lookup';
export const TXRC_UPDATE_PAYMENT_WAS_MADE = '[TXRC] Update Payment Was Made';

// DataCollection page action constants
export const TXRC_STORE_RENEWALINFORMATION_DATA = '[TXRC] Store RenewalInformation Data';
export const TXRC_STORE_ELIGIBILITYQUESTIONS_DATA = '[TXRC] Store EligibilityQuestions Data';

// Address verification constants
export const TXRC_MELISA_SUCCESS = 'SUCCESS';
export const TXRC_MELISA_CONTINUE = 'CONTINUE';
export const TXRC_MELISA_WARNING = 'WARNING';
export const TXRC_MELISA_ERROR = 'ERROR';
export const TXRC_MELISA_ADDRESS_TWO_MISSING = 'ADDRESS_TWO_MISSING';
export const TXRC_MELISA_ADDRESS_TWO_INVALID = 'ADDRESS_TWO_INVALID';
export const TXRC_MELISA_ADDRESS_NOT_VERIFIED = 'ADDRESS_NOT_VERIFIED';
export const TXRC_MELISA_INVALID_ADDRESS = 'INVALID_ADDRESS';

export function storeSelected(data) {
  return {
    type: TXRC_MANAGE_SERVICE_ACTION,
    payload: data,
  };
}

export function storeRenewalInformationData(data) {
  return {
    type: TXRC_STORE_RENEWALINFORMATION_DATA,
    payload: data,
  };
}

export function storeEligibilityQuestionsData(data) {
  return {
    type: TXRC_STORE_ELIGIBILITYQUESTIONS_DATA,
    payload: data,
  };
}


export const manageTXRCServiceAction = (data) => async dispatch => {
  await dispatch(storeBasicInfo(data));
  await dispatch(storeSelected(data));
  return dispatch(getTXRCDetailedLookup());
};

export const clearTXRCData = () => dispatch => {
  dispatch(clearAppData());
  return dispatch({ type: TXRC_TXRCLICENSERENEWAL_CLEAR_DATA });
};

export const setStepsConfig = (stepsConfig) => ({
  type: TXRC_SET_STEPS_CONFIG,
  payload: stepsConfig,
});

// Address verification
export const verifyTXRCMailingAddress = ({ values, formikActions }) => {
  return async dispatch => {
    const formValues = cloneObject(values);
    formValues.address = formatAddressFromForm(formValues.mailingAddress || formValues);

    const [{ body, response }, err] = await to(
      dispatch(userVerifyAddressRequest(formValues.address))
    );

    if (checkRequestFailure({ response, body }))
      return handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);

    if (err) return Promise.reject(err);

    formikActions.setSubmitting(false);

    if (checkRequestFailure({ body, response })) {
      handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);
      return Promise.reject();
    }

    // A modified address was found...prompt user which to use
    if (body.status === TXRC_MELISA_CONTINUE) {
      dispatch(
        openModal('VerifyAddressModal/TXRC', {
          enteredAddress: formValues.address,
          addressOptions: body.data,
        })
      );
    }

    // Action may be needed from user
    if (
      body.status === TXRC_MELISA_WARNING ||
      body.status === TXRC_MELISA_ERROR
    ) {
      switch (body.message) {
        case TXRC_MELISA_ADDRESS_TWO_MISSING:
          dispatch(
            openModal('AddressTwoMissingModal/TXRC', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case TXRC_MELISA_ADDRESS_TWO_INVALID:
          dispatch(
            openModal('AddressTwoIncorrectModal/TXRC', {
              enteredAddress: formValues.address,
              addressOptions: body.data,
            })
          );
          break;
        case TXRC_MELISA_ADDRESS_NOT_VERIFIED:
        case TXRC_MELISA_INVALID_ADDRESS:
          dispatch(
            openModal('AddressCantConfirm/TXRC', {
              enteredAddress: formValues.address,
            })
          );
          break;
        default:
          break;
      }
    }

    return Promise.resolve(body);
  };
};

export function getTXRCDetailedLookup(
  transactionId = 'DETAILEDLOOKUP'
) {
  return async function(dispatch, getStore) {
    const store = getStore();
    const txrc = store.txrc.selected;
    const { userKey, appId, link } = txrc;
    const account = link?.profile?.account?.[0] || {};

    const requestBody = {
      appId,
      userKeys: [userKey],
      transactionId,
      transactionInfo: account,
    };

    const [{ body }, err] = await to(dispatch(lookupAppLinkRequest(requestBody)));

    if (body && body.status === 'SUCCESS' && body.data) {
      dispatch(storeDetailedLookup(body.data));
      return dispatch(push('/txrclicenserenewal'));
    }
    if (body.errors) return Promise.resolve(body);
    if (err) return Promise.reject(err);
  };
}

export function storeDetailedLookup(data) {
  return {
    type: TXRC_STORE_DETAILED_LOOKUP,
    payload: data,
  };
}

export function getLookUpDataAndRenewTXRC({ appId, userKeys, transactionId }) {
  return async function(dispatch) {
    const requestBody = {
      appId,
      userKeys,
      transactionId,
    };
    const [{ body = {} }, err] = await to(
      dispatch(lookupAppLinkRequest(requestBody))
    );
    if (body.data && body.data.profiles && body.data.profiles.length > 0) {
      dispatch(
        manageTXRCServiceAction({
          link: { profile: (body.data || {}).profiles[0] },
          userKey: ((body.data || {}).profiles[0] || {}).userKey,
          appId,
          agencyId: '60',
        })
      );
    }
    if (err) return Promise.reject(err);
    return Promise.resolve(body.data);
  };
}

export const formatTXRCPayment = translate => {
  return async function(dispatch, getStore) {
    const { txrc, user } = getStore();
    const { profile: contDetails = {} } = user;
    const {
      renewalInformationData,
      eligibilityQuestionsData,
      detailedLookup = {},
    } = txrc;
    const {
      userKey,
      appId,
      agencyId,
      link: { profile: { account = {} } = {} },
    } = txrc.selected;
    const [accountDetails] = account;  
    const userKeys = [userKey];
    const paymentDetails = detailedLookup.paymentDetails;
    const mailingAddress = renewalInformationData?.mailingAddress || {};
    const contactDetails = {
      firstName: mailingAddress.firstName,
      middleName: '',
      lastName: mailingAddress.lastName,
      suffix: '',
      entity: '',
      email: contDetails.userEmail,
      phone: contDetails.phoneNum,
      mailingAddress: {
        address1: mailingAddress.streetAddress
          ? mailingAddress.streetAddress
          : null,
        address2: mailingAddress.addressLine2
          ? mailingAddress.addressLine2
          : null,
        city: mailingAddress.city
          ? mailingAddress.city
          : null,
        postalCode: (mailingAddress.zipFive || '') + (mailingAddress.zipFour ? '-' + mailingAddress.zipFour : ''),
        stateProvince: mailingAddress.state?.value || null,
      },
    };
       
    // Merge all data collection page data, excluding mailing address fields
    const { mailingAddress: _, ...collectedData } = {
      ...(renewalInformationData || {}),
      ...(eligibilityQuestionsData || {}),
    };
    
    const renewalFee = paymentDetails
      .filter(fee => fee.paymentDescription == 'Transaction Fee')
      .reduce((accumulator, currentValue) => {
        return accumulator + currentValue.amount;
      }, 0);
    //create the final transaction object
    const transactionInfo = {
      contactDetails: contactDetails,
      ...collectedData,
      transactionAmounts: {
        renewalFee: parseFloat(renewalFee || 0).toFixed(2),
        paymentDetails,
        subTotal: detailedLookup.subTotal,
        paymentDetailsSignature: detailedLookup.paymentDetailsSignature
      },
    };
    return {
      userKeys,
      appId,
      agencyId,
      transactionId: APP_TRANSACTION_IDS.SUBMIT_CREATE_PAYMENT,
      transactionInfo,
    };
  };
};

export const updatePaymentWasMade = (status = false) => {
  return {
    type: TXRC_UPDATE_PAYMENT_WAS_MADE,
    status: status,
  };
};
